import CityAirportTemplate from '../../components/templates/CityAirportTemplate';

export default function TaxiWoerdenRotterdamAirportPage() {
  return (
    <CityAirportTemplate
      city="Woerden"
      airport="rotterdam"
      airportName="Rotterdam The Hague Airport"
      price={75.00}
      distance="65 km"
      duration="52-58 minuten"
    />
  );
}
